
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_URL from "../../config/api";
import Header, { Footer } from "../HomePage/header";
import { useNotification } from "../Notification/notification";
import "./productDetails.css";

function ProductDetails() {
  const { id } = useParams();
  const { notify } = useNotification();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [qty, setQty] = useState(1);
  const [reviewText, setReviewText] = useState("");
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);

        const res = await fetch(`${API_URL}/api/products/${id}`);
        const data = await res.json();

        setProduct(data.product || data);

        const savedReviews =
          JSON.parse(localStorage.getItem(`reviews-${id}`)) || [];
        setReviews(savedReviews);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchProduct();
  }, [id]);

  // CART
  function addToCart() {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const existing = cart.find((item) => item.id === product.id);

    if (existing) existing.quantity += qty;
    else
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        quantity: qty,
      });

    localStorage.setItem("cart", JSON.stringify(cart));
    notify("Added to cart");
  }

  // WISHLIST
  function addToWishlist(e) {
    e.stopPropagation();

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    const exists = wishlist.some((item) => item.id === product.id);

    if (!exists) {
      wishlist.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
      });

      localStorage.setItem("wishlist", JSON.stringify(wishlist));

      notify("Added to wishlist ❤️", "success");
    } else {
      notify("Already in wishlist", "info");
    }
  }

  // REVIEW
  function submitReview() {
    if (!reviewText.trim()) return;

    const newReview = {
      text: reviewText,
      date: new Date().toLocaleDateString(),
    };

    const updated = [...reviews, newReview];
    setReviews(updated);

    localStorage.setItem(`reviews-${id}`, JSON.stringify(updated));
    setReviewText("");
  }

  if (loading) return <h2 className="pd-loading">Loading...</h2>;
  if (!product) return <h2 className="pd-loading">Product not found</h2>;


  const specs = Array.isArray(product?.specifications)
    ? product.specifications
    : [];

  return (
    <>
      <Header />

      <div className="pd-page">
        {/* LEFT */}
        <div className="pd-left">
          <div className="pd-imageWrapper">
            <img src={product.image} alt={product.name} />
            <span className="pd-badge">Best Deal</span>
          </div>

          <div className="pd-section">
            <h3 className="pd-heading">Specifications</h3>

            <div className="pd-specBox">
              {specs.length === 0 && <p>No specifications available</p>}

              {specs.map((s, i) => (
                <div key={i} className="pd-specRow">
                  <span>{s.key}</span>
                  <b>{s.value}</b>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="pd-right">
          <h1 className="pd-title">{product.name}</h1>

          <div className="pd-rating">
            <span className="stars">⭐⭐⭐⭐☆</span>
            <span className="rateText">(4.2)</span>
          </div>

          <h2 className="pd-price">Rs. {product.price}</h2>

          <p className="pd-desc">{product.description}</p>

          <div className="pd-actionBox">
            <div className="pd-qty">
              <button onClick={() => setQty(Math.max(1, qty - 1))}>-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>

            <button className="pd-cart" onClick={addToCart}>
              Add to Cart
            </button>

            <button className="pd-wish" onClick={addToWishlist}>
              ♥ Wishlist
            </button>
          </div>
        </div>

        {/* REVIEWS */}
        <div className="pd-reviewsFull">
          <h3>Customer Reviews</h3>

          <div className="pd-starDisplay">⭐⭐⭐⭐⭐</div>

          <div className="pd-reviewBox">
            {reviews.length === 0 && <p>No reviews yet</p>}

            {reviews.map((r, i) => (
              <div key={i} className="pd-review">
                <p>{r.text}</p>
                <small>{r.date}</small>
              </div>
            ))}
          </div>

          <textarea
            className="pd-textarea"
            placeholder="Write a review..."
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
          />

          <button className="pd-reviewBtn" onClick={submitReview}>
            Submit Review
          </button>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProductDetails;